/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicinesBookDto } from '../../models/medicines-book-dto';

export interface GetFacilityStatusReports$Params {
  customerId: number;
  facilityGroupId: number;
  facilityId: number;
}

export function getFacilityStatusReports(http: HttpClient, rootUrl: string, params: GetFacilityStatusReports$Params, context?: HttpContext): Observable<StrictHttpResponse<MedicinesBookDto>> {
  const rb = new RequestBuilder(rootUrl, getFacilityStatusReports.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.path('facilityGroupId', params.facilityGroupId, {});
    rb.path('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MedicinesBookDto>;
    })
  );
}

getFacilityStatusReports.PATH = '/api/facilitystatusreport/medbook/{customerId}/{facilityGroupId}/{facilityId}';
